// list items in the nav that you want based on their test id
const defaultWatchVideosItems = [
  'menu-watchVideo-search',
  'menu-watchVideos-my-playlist',
  'menu-watchVideos-watch-history',
]
const navItems = {
  registration: {
    default: ['eventMenu-overview', 'eventMenu-getInvolved-callForContent', ...defaultWatchVideosItems],
  },
  countdown: {
    default: [
      'eventMenu-overview',
      'eventMenu-schedule',
      'eventMenu-relatives',
      'eventMenu-getInvolved-callForContent',
      ...defaultWatchVideosItems,
    ],
  },
  conference: {
    default: [
      'eventMenu-overview',
      'eventMenu-schedule',
      'eventMenu-relatives',
      // TODO: add family discovery day when available
      ...defaultWatchVideosItems,
    ],
  },
  afterConference: {
    default: [
      'eventMenu-overview',
      'eventMenu-schedule',
      'eventMenu-relatives',
      'eventMenu-getInvolved-callForContent',
      ...defaultWatchVideosItems,
    ],
  },
  announce: {
    default: [
      'eventMenu-overview',
      'eventMenu-schedule',
      'eventMenu-relatives',
      'eventMenu-getInvolved-callForContent',
      ...defaultWatchVideosItems,
    ],
  },
}

export const navConfig = {
  langCodeBlackList: ['rootstech-slc.familysearch.org', 'cms-z-assets.familysearch.org'],
}

export default navItems
